import {Component, OnInit, inject, ChangeDetectionStrategy} from '@angular/core';
import {Router} from '@angular/router';
import {OidcAuthService} from '../../shared/services/infrastructure/auth/oidc-auth/oidc-auth.service';
import {RedirectService} from '../../shared/services/infrastructure/page/routing/redirect/redirect.service';
import {Links} from '../../shared/common/constants/links';
import {FlowableVariablesService} from '../../shared/services/domain/flowable/core/variables/flowable-variables.service';

@Component({
  selector: 'app-oidc-callback',
  imports: [],
  templateUrl: './oidc-callback.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './oidc-callback.component.scss',
})
export class OidcCallbackComponent implements OnInit {

  private oidcAuthService = inject(OidcAuthService);

  private flowableVariablesService = inject(FlowableVariablesService);

  private redirectService = inject(RedirectService);

  private router = inject(Router);

  async ngOnInit(): Promise<void> {
    await this.checkOidcAuth();
  }

  /**
   * Method: Check auth process
   */
  private async checkOidcAuth(): Promise<void> {
    if (this.oidcAuthService.isAuthProcess()) {
      await this.oidcAuthService.authUserInApp()
        .then(async (redirectUrl: string) => {
          await this.initWindowFlowableFrontendConfiguration();
          await this.redirectService.redirectAfterOidcAuth(redirectUrl);
        })
        .catch(async () => {
          await this.oidcAuthService.renewToken();
          await this.router.navigate([Links.LIBRARY_LINK_URL]);
        });
    } else {
      await this.router.navigate([Links.LIBRARY_LINK_URL]);
    }
  }

  /**
   * Method: Initializes the Flowable frontend configuration for the window.
   */
  private async initWindowFlowableFrontendConfiguration(): Promise<void> {
    await this.flowableVariablesService.initWindowFlowableFrontendConfiguration();
  }

}
